import { useModal } from '@billy/design-system'
import { useCallback, useEffect, useRef, useState } from 'react'

import { ModalId } from '../../../enums/modalId'
import { DEMO_INVOICE_FAKE_SEND_DELAY } from '../constants/demoInvoiceFakeSendDelay'

interface UseDemoInvoiceFakeSendOptions {
  modalId: ModalId
  onSuccess?: () => void
}

export const useDemoInvoiceFakeSend = ({ modalId, onSuccess }: UseDemoInvoiceFakeSendOptions) => {
  const [isSending, setIsSending] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()
  const { close } = useModal(modalId)

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  const fakeSend = useCallback(() => {
    setIsSending(true)

    timeoutRef.current = setTimeout(() => {
      setIsSending(false)
      close()
      onSuccess?.()
    }, DEMO_INVOICE_FAKE_SEND_DELAY)
  }, [close, onSuccess])

  return { fakeSend, isSending }
}
